<div style="display: flex; gap: 10px; height: 100%;">
    <div class="management-pane">
        <div class="row mang-progress-bar">
            <emm-progress-bar [isLoading$]="isMangLoading$"></emm-progress-bar>
        </div>
        <div class="layout-header">
            <div class="selected-screen">
                <h1>{{ (selectedScreen$ | async)?.name | titlecase }}</h1>
            </div>
            <div class="management-search-filter">
                <ng-content select="[layout-center-header]"></ng-content>
            </div>
        </div>
        <div class="layout-content">
            <ng-content select="[layout-center-content]"></ng-content>
        </div>
    </div>
    <div class="management-pane">
        <div *ngIf="isMangLoading$ | async" class="row mang-progress-bar">
            <emm-progress-bar [isLoading$]="isMangLoading$" progress-bar-right></emm-progress-bar>
        </div>
        <div class="layout-header">
            <ng-content select="[layout-right-header]" [style.width]="'100%'"></ng-content>
        </div>
        <div class="layout-content">
            <ng-content select="[layout-right-content]"></ng-content>
        </div>
        <div class="layout-footer">
            <ng-content select="[layout-right-footer]"></ng-content>
        </div>
    </div>
</div>
